module.exports = __webpack_public_path__ + "static/media/gw.0c13655a.svg";